import { Component, OnDestroy, OnInit } from '@angular/core';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { isLoggedIn } from '@core/store/auth/auth.selectors';
import { environment } from '@env/environment';
import { select, Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { Observable, Subscription } from 'rxjs';

declare const window: any;
declare var $: any;
@Component({
  selector: 'app-bottombar',
  templateUrl: './bottombar.component.html',
  styleUrls: ['./bottombar.component.scss']
})
export class BottombarComponent implements OnInit, OnDestroy {

  isLoggedIn$: Observable<boolean>;
  mode = window.mode;

  siteName = environment.sitePrefix.toUpperCase();
  constructor(
    private store: Store<AppState>,
    private eventEmitterService: EventEmitterService,
  ) { }

  ngOnInit() {
    this.isLoggedIn$ = this.store.pipe(select(isLoggedIn));

    this.eventEmitterService.liveChatWidgetVar = this.eventEmitterService.liveChatWidgetEmitter.subscribe(() => {
      this.openLiveChat();
    });
  }

  ngOnDestroy() {

  }

  private openLiveChat(){
    if (window.LiveChatWidget) {
      window.LiveChatWidget.on('ready', function () {
        window.LiveChatWidget.call('maximize');
      });
    }
  }
}
